module.exports = __webpack_public_path__ + "img/security.0903dc15.svg";